// extracted by mini-css-extract-plugin
module.exports = {"icon":"TriangleIcon__icon___3dVwi","outline":"TriangleIcon__outline___24Sjp"};